const MAX_SAFE_INTEGER = 9007199254740991;

function isLength(value: number): boolean {
  // eslint-disable-next-line eqeqeq
  return typeof value === 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

function isArray(value: Array<unknown>): boolean {
  return value != null && typeof value !== 'function' && isLength(value.length);
}

export default isArray;
